module.exports = __webpack_public_path__ + "img/color_rosegold_a-1755-1@2x.8d3b634.jpg";